<template>
  <div class="atab">
    <div class="title" ref="tabs_wrap">
      <p
        class="t_item"
        v-for="(t, i) in tab"
        :key="i"
        :class="{ pactive: i == currentIndex }"
        @click="changeTab(i)"
      >
        {{ t.name }}
      </p>
    </div>
    <div class="cont">
      <div
        class="cont_item"
        v-for="(t, i) in tab"
        :key="i"
        v-show="i == currentIndex"
      >
        <img
          class="pic"
          :src="`https://todeskcdnspeed.todesk.com/mobile/ascense/${t.img}`"
          alt=""
          v-touch:swipe.left="touchLeft"
          v-touch:swipe.right="touchRight"
        />
        <div class="item_text">{{ t.msg }}</div>
        <div class="desc_bx">
          <div class="desc_item" v-for="(ts, is) in t.desc" :key="is">
            {{ ts }}
          </div>
        </div>
        <a :href="t.link" class="desc_link">了解详情</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab: [
        {
          index: 0,
          name: "高清设计",
          img: "scense_pic1.png",
          desc: [
            "顺畅运行大 型程序",
            "4K 画质，<0.04秒延时",
            "数字资产不  离公司设备",
          ],
          msg: "远程控制工作站进行设计制图、建模渲染、视频剪辑",
          link: "#/solutions/design",
        },
        {
          index: 1,
          name: "远程办公",
          img: "scense_pic2.png",
          desc: ["随时随地远 程办公", "支持账户-设备1V1绑定", "精细管控操作权限"],
          msg: "流畅稳定连接公司电脑，严格账户认证与数据保护",
          link: "#/solutions/telework",
        },
        {
          index: 2,
          name: "技术支持",
          img: "scense_pic3.png",
          desc: [
            "提升服务质 量和效率",
            "免安装被控 端更简便",
            "服务流程记 录可回查",
          ],
          msg: "向客户快速提供使用指导、问题排查、故障维修",
          link: "#/enterprise",
        },
        {
          index: 3,
          name: "公司IT管理",
          img: "scense_pic4.png",
          desc: ["IT部门降本     增效", "分组架构高 效管理", "支持私有化 部署"],
          msg: "IT部门为内部员工解决电脑问题，并高效管理公司设备",
          link: "#/enterprise",
        },
        {
          index: 4,
          name: "远程运维",
          img: "scense_pic5.png",
          desc: ["远程巡检与排障", "有效缩短故障时长", "全流程安全审计"],
          msg: "运维人员远程进行大量设备巡检、系统维护、软件升级",
          link: "#/enterprise",
        },
      ],
      currentIndex: 0,
      CLIENTWIDTH: null,
    };
  },
  watch: {
    currentIndex(val) {
      if (val === 0) {
        this.$refs.tabs_wrap.scroll({
          left: 0,
          behavior: "smooth",
        });
        return;
      }
      if (val === this.tab.length - 1) {
        this.$refs.tabs_wrap.scroll({
          left: 3 * this.CLIENTWIDTH,
          behavior: "smooth",
        });
        return;
      }
      console.log(this.$refs.tabs_wrap);
      this.$refs.tabs_wrap.scroll({
        left: (val - 1) * 0.26 * this.CLIENTWIDTH,
        behavior: "smooth",
      });
    },
  },
  created() {},
  mounted() {
    this.CLIENTWIDTH = document.documentElement.clientWidth || 0;
  },
  methods: {
    touchLeft() {
      if (this.currentIndex == this.tab.length - 1) {
        this.currentIndex = 0;
      } else {
        this.currentIndex++;
      }
    },
    touchRight() {
      if (this.currentIndex == 0) {
        this.currentIndex = this.tab.length - 1;
      } else {
        this.currentIndex--;
      }
    },
    changeTab(index) {
      this.currentIndex = index;
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.atab {
  background: #29303a;
  padding-bottom: 32px;
  .title {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    padding-top: 26px;
    padding-bottom: 16px;
    &::-webkit-scrollbar {
      display: none;
    }
    .t_item {
      display: inline-block;
      margin-left: 12px;
      margin-right: 12px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      opacity: 0.3;
      position: relative;
      &::before {
        position: absolute;
        content: "";
        top: 30px;
        left: 50%;
        width: 30px;
        height: 2px;
        background: #0070f9;
        border-radius: 1px;
        display: none;
        margin: auto;
        transform: translateX(-50%);
      }
      &.pactive {
        opacity: 1;
        font-size: 20px;
        &::before {
          display: block;
        }
      }
    }
  }
  // .line{
  //   width: 336px;
  //   margin: auto;
  //   margin-top: 10px;
  //   border-bottom: 1PX solid #616369;
  //   display: flex;
  //   .line_item{
  //     width: 56px;
  //     height: 2PX;
  //     background: transparent;
  //     border-radius: 1PX;
  //     position: relative;
  //     top: 1PX;
  //     &.lactive{
  //       background: #3187F0;
  //     }
  //   }
  // }
  .cont {
    margin-top: 12px;
    .cont_item {
      .pic {
        width: 100%;
        height: auto;
      }
      .item_text {
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        margin: auto;
        margin-top: -5px;
        width: 290px;
      }
      .desc_bx {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        .desc_item {
          margin-left: 6px;
          margin-right: 6px;
          width: 101px;
          height: 54px;
          border-radius: 7px;
          border: 1px solid #494e55;
          box-sizing: border-box;
          padding: 0 12px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #cacccf;
          padding-right: 5px;
          display: flex;
          align-items: center;
        }
      }
      .desc_link {
        display: block;
        margin: auto;
        margin-top: 27px;
        width: 189px;
        height: 50px;
        background: #0065DD;
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
      }
      .desc_link:active {
        background: #1c87fd;
      }
    }
  }
}
</style>
